export const formatDate = (languageCode, date, isMonthly = false) => {
    const dateObj = isMonthly ? new Date(date + '-01') : new Date(date);
    return isMonthly
        ? dateObj.toLocaleString(languageCode, { month: 'short', year: 'numeric' })
        : dateObj.toLocaleString(languageCode, { month: 'short', day: '2-digit' });
};

export const formatDateFull = (languageCode, date, isMonthly = false) => {
    const dateObj = isMonthly ? new Date(date + '-01') : new Date(date);
    return isMonthly
        ? dateObj.toLocaleString(languageCode, { month: 'long', year: 'numeric' })
        : dateObj.toLocaleString(languageCode, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              weekday: 'short',
          });
};

export const secondsToHumanReadable = (seconds: number, unit = undefined, locale = undefined): [string, string] => {
    const pad = (n: number) => n.toString().padStart(2, '0');

    const s = Math.floor(seconds);

    // Auto-select unit if none provided
    if (unit === undefined) {
        const days = Math.floor(s / 86400);
        const hours = Math.floor((s % 86400) / 3600);
        const mins = Math.floor((s % 3600) / 60);

        if (days > 0) unit = 'd';
        else if (hours > 0) unit = 'h';
        else if (mins > 0) unit = 'min';
        else unit = 's';
    }

    if (unit === 's') {
        return [`${pad(s)}`, 's'];
    } else if (unit === 'min') {
        const mins = Math.floor(s / 60);
        const secs = s % 60;
        return [`${pad(mins)}:${pad(secs)}`, 'min'];
    } else if (unit === 'h') {
        const hours = Math.floor(s / 3600);
        const mins = Math.floor((s % 3600) / 60);
        return [`${pad(hours)}:${pad(mins)}`, 'h'];
    } else if (unit === 'd') {
        const days = (s / 86400).toLocaleString(locale, { maximumFractionDigits: 2 });
        return [days, 'd'];
    } else {
        throw new Error(`Invalid unit: ${unit}`);
    }
};

export const aggregateByMonth = (data: Record<string, number>[], fields: string[]) => {
    const monthlyData = {};

    data.forEach((item) => {
        const date = new Date(item.date);
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

        if (!monthlyData[monthKey]) {
            monthlyData[monthKey] = { date: monthKey };
            fields.forEach((field) => {
                monthlyData[monthKey][field] = 0;
            });
        }

        fields.forEach((field) => {
            monthlyData[monthKey][field] += item[field] || 0;
        });
    });

    return Object.values(monthlyData);
};

export const getTicks = (numTicks: number, maxValue: number) => {
    return Array.from({ length: numTicks }, (_, i) => (i * maxValue) / (numTicks - 1));
};
